<template>
  <div>
    No token found in the url
  </div>
</template>